<template>
  <div class="policy">
    <common-layout>
      <div slot="header">
        <div class="policy_tabs">
          <span
            v-for="btn in tabs"
            :key="btn.id"
            @click="handleClick(btn.id)"
            :class="{ active_t: category == btn.id }"
          >
            {{ btn.name }}
          </span>
        </div>
        <!-- <ul class="policey_nav">
          <li>内容管理</li>
          <li class="active-Tab">政策服务</li>
        </ul> -->
      </div>
      <div slot="container">
        <div class="policy-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623aa2; border: none"
          >
            新增
          </el-button>
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="params.keyword"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <!-- <div class="selectType" v-if="params.category !== 1">
            <span>类型：</span>
            <el-select v-model="type" placeholder="请选择" clearable @change="selectType">
              <el-option label="全部" value></el-option>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div> -->
        </div>
        <div id="table">
          <!--动态绑定长宽-->
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            type="index"
            @selection-change="tabSelect"
            :header-cell-style="headerStyle"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (params.page - 1) * params.pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题" align="center"></el-table-column>
            <el-table-column prop="publishedTime" label="时间" align="center"></el-table-column>
            <el-table-column prop="publishedFlag" label="是否发布" align="center" width="100">
              <template slot-scope="scope">
                <el-tag type="success" v-if="Number(scope.row.publishedFlag) == 1">已发布</el-tag>
                <el-tag type="info" v-else>未发布</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <!-- <el-button-group> -->
                <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
                  删除
                </el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="preview(scope.row)"
                  v-if="scope.row.publishedFlag == 0"
                >
                  确定发布
                </el-button>
                <el-button size="mini" type="warning" @click="preview(scope.row)" v-else>
                  取消发布
                </el-button>
                <!-- </el-button-group> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          :page-size="params.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <!--    <el-tabs v-model="activeName">
      <el-tab-pane label="国家级政策" name="1"></el-tab-pane>
      <el-tab-pane label="省级政策" name="2"></el-tab-pane>
      <el-tab-pane label="市级政策" name="3"></el-tab-pane>
      <el-tab-pane label="政策解读" name="4"></el-tab-pane>
    </el-tabs>-->

    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form
        v-if="dialogFormVisible"
        :model="ruleForm"
        ref="ruleForm"
        label-width="105px"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-row :span="24">
          <el-col :span="category === 1 ? 12 : 24">
            <el-form-item label="标题" prop="title">
              <el-input v-model="ruleForm.title" clearable></el-input>
            </el-form-item>
            <el-form-item label="副标题" prop="subtitle">
              <el-input v-model="ruleForm.subtitle" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间" prop="publishedTime">
              <el-date-picker
                v-model="ruleForm.publishedTime"
                :picker-options="pickerOptions"
                type="datetime"
                placeholder="选择日期"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="text-align: left; width: 100%"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="所属年度" prop="year">
              <el-date-picker
                v-model="ruleForm.annual"
                :picker-options="pickerOptions"
                type="year"
                placeholder="选择年度"
                format="yyyy"
                value-format="yyyy"
                style="text-align: left; width: 100%"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="类型" prop="subCategory" v-if="options.length > 0">
              <el-select
                v-model="ruleForm.subCategory"
                placeholder="请选择"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.category"
                  :label="item.name"
                  :value="item.category"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="category === 1 ? 12 : 0" v-if="category === 1">
            <el-form-item label="封面:" prop="imgUrl">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img
                  v-if="ruleForm.imgUrl"
                  :src="imgUrl + ruleForm.imgUrl"
                  class="img_border"
                  style="max-width: 233px;max-height: 154px;"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !ruleForm.imgUrl }"
                ></i>
                <span class="upload_btn" v-if="!ruleForm.imgUrl">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="ruleForm.imgUrl">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="content">
          <!-- <editor :quill-data="ruleForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
          <editor
            v-model="ruleForm.content"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
          ></editor>
        </el-form-item>
        <el-form-item style="text-align: left">
          <el-col :span="6">
            <el-form-item label="发布:" prop="publishedFlag" style="text-align: left">
              <el-col :span="24">
                <el-switch
                  v-model="ruleForm.publishedFlag"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="推荐:" prop="recommendStatus" style="text-align: left">
              <el-col :span="24">
                <el-switch
                  v-model="ruleForm.recommendStatus"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="热门:" prop="popularStatus" style="text-align: left">
              <el-col :span="24">
                <el-switch
                  v-model="ruleForm.popularStatus"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                ></el-switch>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="text-align: right">
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="closeForm('ruleForm')">取消</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import editor from "../../components/yhQuillEditor";
import editor from '../../components/tinymce-editor/tinymce-editor';
import CommonLayout from '../../components/common-layout.vue';
import { DisabledDateFn } from '../../utils/tool';
export default {
  components: {
    editor,
    CommonLayout,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      is_submit: true,
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE',
      },
      params: {
        keyword: '',
        page: 1,
        pageSize: 10,
        category: 1,
      },
      category: 1,
      tabs: [
        {
          id: 1,
          name: '时政要闻',
          category: 1,
          list: [],
        },
        {
          id: 2,
          name: '思想政治建设',
          category: 2,
          list: [],
        },
        {
          id: 3,
          name: '组织建设',
          category: 1,
          list: [
            { name: '组织架构图', category: 1 },
            { name: '组织设置规范', category: 2 },
            { name: '资料下载', category: 3 },
          ],
        },
        {
          id: 4,
          name: '组织生活',
          category: 2,
          list: [
            { name: '组织生活制度', category: 4 },
            { name: '组织生活', category: 5 },
          ],
        },
        {
          id: 5,
          name: '党员队伍建设',
          category: 3,
          list: [
            { name: '党员发展流程图', category: 6 },
            { name: '党员管理规范', category: 7 },
            { name: '资料下载', category: 3 },
          ],
        },
        {
          id: 6,
          name: '党风廉政建设',
          category: 3,
          list: [],
        },
        {
          id: 7,
          name: '党务公开',
          category: 4,
          list: [
            { name: '党务公开规范', category: 8 },
            { name: '党务公开', category: 9 },
          ],
        },
        {
          id: 8,
          name: '支部党建',
          category: 5,
          list: [
            { name: '支部动态', category: 10 },
            { name: '支部风采', category: 11 },
          ],
        },
        {
          id: 9,
          name: '党建资料库',
          category: 4,
          list: [],
        },
      ],
      selected: '',
      total: 10,
      dialogFormVisible: false,
      Title: '',
      tableData: [],
      ruleForm: {
        title: '',
        subtitle: '',
        publishedTime: '',
        subCategory: '',
        content: '',
        publishedFlag: true,
        recommendStatus: true,
        popularStatus: true,
        annual: '',
      },
      options: [],
      rules: {
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur',
          },
        ],
        imgUrl: [
          {
            required: true,
            message: '请上传封面',
            trigger: 'blur',
          },
        ],
        publishedTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        annual: [
          {
            required: true,
            message: '请选择年度',
            trigger: 'change',
          },
        ],
        subCategory: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'change',
          },
        ],
        content: [
          {
            required: true,
            message: '请输入内容',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getDate() {
      var url = [1, 2, 6, 9].includes(this.category)
        ? `${urlConfig.devUrl}apij2/admin-api/partybuild/party-political-news/page`
        : `${urlConfig.devUrl}apij2/admin-api/partybuild/party-org-building/page`;
      this.http.post(url, this.params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.$message.error('获取数据失败！！');
        }
      });
    },
    //新增
    add() {
      this.Title = '新建';
      this.dialogFormVisible = true;
      this.options = this.tabs[this.category - 1].list;
      this.ruleForm = {
        category: this.tabs[this.category - 1].category,
        title: '',
        imgUrl:'',
        readingCount: 0,
        subtitle: '',
        publishedTime: '',
        annual: '',
        subCategory: '',
        content: '',
        publishedFlag: true,
        recommendStatus: true,
        popularStatus: true,
      };
      if (this.tabs[this.category - 1].list.length > 0) {
        this.ruleForm.subCategory = this.tabs[this.category - 1].list[0].category;
      }
    },
    //编辑
    handleEdit(val) {
      this.Title = '编辑';
      this.dialogFormVisible = true;
      var url = [1, 2, 6, 9].includes(this.category)
        ? `${urlConfig.devUrl}apij2/admin-api/partybuild/party-political-news/get`
        : `${urlConfig.devUrl}apij2/admin-api/partybuild/party-org-building/get`;
      this.http.get(url+'?id='+val.id).then(res => {
        if (res.code == 0) {
          this.ruleForm = res.data;
        }
      });
    },

    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, 'HouImg');
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
        .then(rst => {
          this.http
            .post('/file/base64_upload', {
              image: rst.base64,
            })
            .then(res => {
              this.ruleForm.imgUrl = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    handlePictureCardPreview(file) {
      this.ruleForm.imgUrl = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.ruleForm.imgUrl;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          this.ruleForm.imgUrl = '';
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //提交
    submitForm(formName) {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          if (!obj.id) {
            var url = [1, 2, 6, 9].includes(this.category)
              ? `${urlConfig.devUrl}apij2/admin-api/partybuild/party-political-news/create`
              : `${urlConfig.devUrl}apij2/admin-api/partybuild/party-org-building/create`;
            this.http.post(url, obj).then(res => {
              if (res.code == 0) {
                this.$message.success('新建成功');
                this.getDate();
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
                this.is_submit = true;
              }
            }).catch(error =>{
                this.is_submit = true;
            });
          } else {
            var url = [1, 2, 6, 9].includes(this.category)
              ? `${urlConfig.devUrl}apij2/admin-api/partybuild/party-political-news/update`
              : `${urlConfig.devUrl}apij2/admin-api/partybuild/party-org-building/update`;
            this.http.post(url, obj).then(res => {
              console.log(res);
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.getDate();
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
                this.is_submit = true;
              }
            }).catch(error =>{
                this.is_submit = true;
            });
          }
        } else {
          this.is_submit = true;
          return false;
        }
      });
    },
    //取消
    closeForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    //发布
    preview(e) {
      let data = e;
      if (e.publishedFlag == 1) {
        data.publishedFlag = 0;
      } else {
        data.publishedFlag = 1;
      }
      var url = [1, 2, 6, 9].includes(this.category)
        ? `${urlConfig.devUrl}apij2/admin-api/partybuild/party-political-news/update`
        : `${urlConfig.devUrl}apij2/admin-api/partybuild/party-org-building/update`;
      this.http.post(url, data).then(res => {
        if (res.code == 0) {
          if (e.publishedFlag == 1) {
            this.$message.success('发布成功');
          } else {
            this.$message.success('已取消发布');
          }
          this.getDate();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //搜索
    search() {
      this.getDate();
    },
    selectType(e) {
      this.getDate();
    },
    //删除
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          var url = [1, 2, 6, 9].includes(this.category)
            ? `${urlConfig.devUrl}apij2/admin-api/partybuild/party-political-news/deletes`
            : `${urlConfig.devUrl}apij2/admin-api/partybuild/party-org-building/deletes`;
          this.http.post(url, { ids: [row.id] }).then(res => {
            // this.http.request(url +'/'+ row.id, {id:row.id}, 'delete').then(res => {
            if (res.code == 0) {
              this.getDate();
              this.$message({
                type: 'success',
                message: '删除成功',
              });
            } else {
              this.$message({
                message: '失败！',
                type: 'error',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //批量删除
    deleteAll() {
      if (this.selected) {
        this.$confirm('确定删除文件吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
        })
          .then(() => {
            var url = [1, 2, 6, 9].includes(this.category)
              ? `${urlConfig.devUrl}apij2/admin-api/partybuild/party-political-news/deletes`
              : `${urlConfig.devUrl}apij2/admin-api/partybuild/party-org-building/deletes`;
            this.http.post(url, { ids: this.selected.split(',') }).then(response => {
              if (response.code == 0) {
                this.$message.success('删除成功！');
                this.getDate('Policy?category_first=' + this.params.category);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      } else {
        this.$message({
          type: 'warning',
          message: '请选择删除的文件',
        });
      }
    },
    //富文本
    getQuillData(val) {
      this.ruleForm.content = val;
    },
    //翻页
    handleCurrentChange(val) {
      this.getDate();
    },
    //选择行数
    tabSelect(sec) {
      let ids = '';
      for (let i of sec) {
        ids += i.id + ',';
      }
      ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    // 切换tab
    handleClick(val) {
      this.params.category = this.tabs[Number(val) - 1].category;
      this.category = val;
      this.getDate();
    },
  },
};
</script>

<style lang="scss" scoped>
.policy {
  height: 100%;

  .policy-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;

    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }

    .selectType {
      display: inline-block;
    }
  }

  .policy_tabs {
    width: 1350px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }

  .policey_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      &.active-Tab {
        color: rgba(255, 255, 255, 0.4);

        &:before {
          display: inline-block;
          padding-right: 0.5rem;
          padding-left: 0.5rem;
          color: rgba(255, 255, 255, 0.4);
          content: '/';
        }
      }
    }
  }

  #table {
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ th {
      // background-color: #eef1f6 !important;
      // color: #000;
    }

    /deep/ td {
    }

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .blue {
      color: #47eb0d;
    }

    .red {
      color: red;
    }
  }

  /deep/ .yh-quill-editor {
    .el-upload {
      display: none;
    }

    .ql-toolbar {
      text-align: left;
    }
  }
}
.avatar-uploader {
  text-align: center;
  width: 243px;
  height: 198px;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}
</style>
